import { Table, TableEmpty } from '@src/application/modules/shared/components/Table/Table';
import { FsCampaign } from '@src/application/modules/flagship/type';
import { QATest } from '@src/application/modules/tag/shared/tag/types';
import { Campaign } from '../Campaign/Campaign';
import { FsCampaignFooter } from '@src/application/modules/flagship/components/Campaigns/Footer/FsCampaignFooter';
import { useIsFs } from '@src/application/modules/flagship/hooks/fsHooks';
import { CampaignType, ColumnHeaders } from '@application/modules/shared/type';
import { PageLoader } from '@src/application/modules/tag/Layout/components/PageLoader/PageLoader';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { styled } from 'styled-components';

export type CampaignBlockProps = {
  tests: FsCampaign[] | QATest[];
  title?: string;
  noDataMessage?: string;
  type?: CampaignType;
  headers: ColumnHeaders;
  headerComponent?: ReactNode;
  isLoading?: boolean;
};

const StyledPageLoader = styled(PageLoader)`
  padding: 8px;
`;

const CampaignBlockWrapper = ({ tests, type, headers }: Omit<CampaignBlockProps, 'title' | 'noDataMessage'>) => {
  const isFs = useIsFs();
  return (
    <>
      {tests.map((test, index) => (
        <Campaign key={`${test.id}${index}`} test={test} header={headers} type={type} />
      ))}
      {isFs && type === 'page' && <FsCampaignFooter />}
    </>
  );
};

export function CampaignBlock({
  tests,
  title,
  noDataMessage,
  type,
  headers,
  headerComponent,
  isLoading,
}: CampaignBlockProps) {
  const { t } = useTranslation();
  return (
    <Table
      title={title}
      headers={Object.values(headers)}
      withBorderRow={false}
      hideHeaderRow={!tests.length}
      headerComponent={headerComponent}
    >
      {isLoading && <StyledPageLoader text={t('Loading ...')} />}
      {tests.length ? (
        <CampaignBlockWrapper tests={tests} type={type} headers={headers} />
      ) : (
        noDataMessage && <TableEmpty noDataMessage={noDataMessage} />
      )}
    </Table>
  );
}
